module.exports = __webpack_public_path__ + "static/media/sales.98b71e04.svg";